import { processStepsTrns } from "src/page-components/opportunities/trns";

export const SIDEBAR_ITEMS = [
  {
    id: "search-select",
    title: { i18nKey: processStepsTrns.searchAndSelectTitle },
    subtitles: [
      {
        id: "use-filters",
        subtitle: {
          i18nKey: processStepsTrns.searchAndSelectUseFiltersSubtitle,
        },
      },
      {
        id: "review-offers",
        subtitle: {
          i18nKey: processStepsTrns.searchAndSelectReviewOffersSubtitle,
        },
      },
    ],
  },

  {
    id: "purchase",
    title: { i18nKey: processStepsTrns.purchaseTitle },
    subtitles: [
      {
        id: "click",
        subtitle: {
          i18nKey: processStepsTrns.purchaseClickSubtitle,
        },
      },
    ],
  },

  {
    id: "agreement",
    title: { i18nKey: processStepsTrns.agreementConclusionTitle },
    subtitles: [
      {
        id: "preliminary",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionPreliminarySubtitle,
        },
      },
      {
        id: "signing",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionSigningSubtitle,
        },
      },
      {
        id: "payment",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionPaymentSubtitle,
        },
      },
      {
        id: "document-transfer",
        subtitle: {
          i18nKey: processStepsTrns.agreementConclusionDocumentTransferSubtitle,
        },
      },
    ],
  },

  {
    id: "completion",
    title: { i18nKey: processStepsTrns.completionTitle },
    subtitles: [
      {
        id: "confirmation",
        subtitle: {
          i18nKey: processStepsTrns.completionConfirmationSubtitle,
        },
      },
      {
        id: "buyer-support",
        subtitle: {
          i18nKey: processStepsTrns.completionBuyerSupportSubtitle,
        },
      },
    ],
  },

  {
    id: "business-launch",
    title: { i18nKey: processStepsTrns.businessLaunchTitle },
    subtitles: [
      {
        id: "implementation",
        subtitle: {
          i18nKey: processStepsTrns.businessLaunchImplementationSubtitle,
        },
      },
      {
        id: "scaling",
        subtitle: {
          i18nKey: processStepsTrns.businessLaunchScalingSubtitle,
        },
      },
    ],
  },
];
